import React, { useState } from 'react';
import { API_ENDPOINTS } from '../../constants';
import TagsInput from '../../components/TagsInput';

function TagInputContainer({ tags: stateTags = [], id, name }) {
  const [tags, setTags] = useState(stateTags);

  return (
    <>
      <input type="hidden" name={name} value={tags} />

      <TagsInput
        id={id}
        suggestionsEndpoint={API_ENDPOINTS.tagSearch}
        value={tags}
        onChange={setTags}
      />
    </>
  );
}

export default TagInputContainer;
